import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "@royalty/module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { CoreErrorDialogComponent } from "./error-conflict.component";
import { ErrorConflictDialogService } from "./error-conflict.service";

@NgModule({
	imports: [MatButtonModule, MatDialogModule, SharedModule],
	providers: [ErrorConflictDialogService],
	declarations: [CoreErrorDialogComponent],
	entryComponents: [CoreErrorDialogComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorConflictDialogModule {}
